module.exports = __webpack_public_path__ + "img/galalh.14641284.jpg";